<script>
import { mapActions } from "vuex";
import AggregatorsTable from "../elements/AggregatorsTable";
import ServerMetaData from "../elements/ServerMetaData";
import SingleAggregatorTable from "../elements/SingleAggregatorTable.vue";
import ContactCard from "../layout/ContactCard";

export default {
  components: {
    ContactCard,
    AggregatorsTable,
    ServerMetaData,
    SingleAggregatorTable,
  },
  data() {
    return {
      serverName: "",
      contactsList: [],
      aggregatorList: [],
    };
  },
  methods: {
    ...mapActions("request", ["fetchZegebaContacts"]),
    getContacts() {
      return this.fetchZegebaContacts().then(
        (res) => (this.contactsList = res)
      );
    },
    addAggregatorTable(aggregator) {
      this.aggregatorList.push(aggregator);
    },
  },
  created() {
    this.serverName = this.$route.params.serverName;
  },
  mounted() {
    this.getContacts();
  },
};
</script>

<template>
  <div>
    <div>
      <v-container fluid>
        <v-row>
          <v-col cols="12" class="title">
            <h2>{{ serverName }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <server-meta-data :domain="serverName" />
            <contact-card :contactsList="contactsList" />
          </v-col>
          <v-col cols="12" md="6">
            <v-card>
              <v-card-title>Aggregators</v-card-title>
              <v-card-text>
                <aggregators-table
                  :domain="serverName"
                  @pushAggregator="addAggregatorTable"
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-for="aggregator in aggregatorList"
            :key="aggregator.name"
          >
            <single-aggregator-table
              :aggregator="aggregator"
              v-if="aggregator.table && aggregator.headers"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<style scoped>
.title {
  text-align: center;
}
.v-card__title {
  padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/views/ServerStatusInfo.vue